module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    attrs: {
      "id": "wrap_all"
    }
  }, [_c('div', {
    staticClass: "container_wrap footer_color",
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "flex_column av_one_fourth first el_before_av_one_fourth"
  }, [_c('section', {
    staticClass: "widget clearfix widget_text",
    attrs: {
      "id": "text-3"
    }
  }, [_c('div', {
    staticClass: "textwidget"
  }, [_c('p', [_c('a', {
    staticClass: "alignnone",
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "position": "relative",
      "overflow": "hidden"
    },
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "alignnone size-full wp-image-266",
    attrs: {
      "loading": "lazy",
      "src": "https://zadbano.pl/wp-content/uploads/2021/01/logo-blue.png",
      "alt": "",
      "width": "300",
      "height": "50"
    }
  }), _c('span', {
    staticClass: "image-overlay overlay-type-extern"
  }, [_c('span', {
    staticClass: "image-overlay-inside"
  })])])])]), _vm._v(" "), _c('span', {
    staticClass: "seperator extralight-border"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex_column av_one_fourth el_after_av_one_fourth el_before_av_one_fourth"
  }, [_c('section', {
    staticClass: "widget_text widget clearfix widget_custom_html",
    attrs: {
      "id": "custom_html-3"
    }
  }, [_c('div', {
    staticClass: "textwidget custom-html-widget"
  }), _vm._v(" "), _c('span', {
    staticClass: "seperator extralight-border"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex_column av_one_fourth el_after_av_one_fourth el_before_av_one_fourth"
  }, [_c('section', {
    staticClass: "widget clearfix widget_text",
    attrs: {
      "id": "text-2"
    }
  }, [_c('div', {
    staticClass: "textwidget"
  }, [_c('p', [_vm._v("ul. Wał Miedzeszyński 251")]), _vm._v(" "), _c('p', [_vm._v("04-866 Warszawa")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:kontakt@zadbano.pl"
    }
  }, [_vm._v("kontakt@zadbano.pl")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "tel:+48225261000"
    }
  }, [_vm._v("+48 22 526 1000")])])]), _vm._v(" "), _c('span', {
    staticClass: "seperator extralight-border"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex_column av_one_fourth el_after_av_one_fourth el_before_av_one_fourth"
  }, [_c('section', {
    staticClass: "widget clearfix widget_nav_menu",
    attrs: {
      "id": "nav_menu-2"
    }
  }, [_c('div', {
    staticClass: "menu-footer-menu-container"
  }, [_c('ul', {
    staticClass: "menu",
    attrs: {
      "id": "menu-footer-menu"
    }
  }, [_c('li', {
    staticClass: "menu-item menu-item-type-post_type menu-item-object-page menu-item-156",
    attrs: {
      "id": "menu-item-156"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://zadbano.pl/o-nas/"
    }
  }, [_vm._v("O nas")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item menu-item-type-post_type menu-item-object-page menu-item-157",
    attrs: {
      "id": "menu-item-157"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://zadbano.pl/uslugi/"
    }
  }, [_vm._v("Usługi")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item menu-item-type-post_type menu-item-object-page menu-item-158",
    attrs: {
      "id": "menu-item-158"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://zadbano.pl/rozwiazania/"
    }
  }, [_vm._v("Rozwiązania")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item menu-item-type-post_type menu-item-object-page menu-item-159",
    attrs: {
      "id": "menu-item-159"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://zadbano.pl/wspolpraca/"
    }
  }, [_vm._v("Współpraca")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item menu-item-type-post_type menu-item-object-page menu-item-160",
    attrs: {
      "id": "menu-item-160"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://zadbano.pl/regulaminy-i-dokumenty/"
    }
  }, [_vm._v("Regulaminy i dokumenty")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item menu-item-type-post_type menu-item-object-page menu-item-161",
    attrs: {
      "id": "menu-item-161"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://zadbano.pl/polityka-prywatnosci/"
    }
  }, [_vm._v("Polityka prywatności")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item menu-item-type-post_type menu-item-object-page menu-item-162",
    attrs: {
      "id": "menu-item-162"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://zadbano.pl/kontakt/"
    }
  }, [_vm._v("Kontakt")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item menu-item-type-custom menu-item-object-custom menu-item-163",
    attrs: {
      "id": "menu-item-163"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Zaloguj")])])])]), _vm._v(" "), _c('span', {
    staticClass: "seperator extralight-border"
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e50e5ea","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageFooter.vue
// module id = 263
// module chunks = 1